// components/JSONViewer/JSONViewer.jsx
import React from 'react';
import './JSONViewer.css';

const JSONViewer = ({ 
  data, 
  title = "JSON Data", 
  showCopyButton = true,
  showDownloadButton = true,
  downloadFileName = "data",
  height = "400px",
  className = "" 
}) => {


  const formatJSON = (obj) => {
    try {
      return JSON.stringify(obj, null, 2);
    } catch (error) {
      return "Error: Unable to format JSON";
    }
  };

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(formatJSON(data));
      // Opcional: agregar un toast o notificación de éxito
      console.log('JSON copied to clipboard');
    } catch (error) {
      // Fallback para navegadores que no soporten clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = formatJSON(data);
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      console.log('JSON copied to clipboard (fallback)');
    }
  };

  const handleDownloadJSON = () => {
    try {
      const jsonString = formatJSON(data);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      
      // Crear elemento de descarga temporal
      const link = document.createElement('a');
      link.href = url;
      
      // Generar nombre de archivo con timestamp si no se proporciona uno específico
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').split('T')[0];
      const fileName = `${downloadFileName}_${timestamp}.json`;
      
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      // Limpiar
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      console.log(`JSON downloaded as ${fileName}`);
    } catch (error) {
      console.error('Error downloading JSON:', error);
    }
  };

  if (!data) {
    return (
      <div className={`json-viewer-container ${className}`}>
        <div className="json-empty-state">
          <span>No data available</span>
        </div>
      </div>
    );
  }

  const showHeader = Boolean(title) || showCopyButton || showDownloadButton;

  return (
    <div className={`json-viewer-container ${className}`}>
      {showHeader && (
      <div className="json-viewer-header">
        <span className="json-viewer-title">{title}</span>
        <div className="json-actions">
          
          {showCopyButton && (
            <button 
              className="json-action-btn json-copy-btn"
              onClick={handleCopyToClipboard}
              title="Copy JSON to clipboard"
            >
              📋 Copy
            </button>
          )}
          {showDownloadButton && (
            <button 
              className="json-action-btn json-download-btn"
              onClick={handleDownloadJSON}
              title="Download JSON file"
            >
              💾 Download
            </button>
          )}
        </div>
      </div>
      )}
      <pre 
        className="json-viewer-content"
        style={{ maxHeight: height }}
      >
        <code>{formatJSON(data)}</code>
      </pre>
    </div>
  );
};

export default JSONViewer;